import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Collapse,
  Grid,
  IconButton,
  Button,
  Badge,
  Typography,
} from '@material-ui/core'
import { ReactComponent as Tune } from 'assets/img/ic_filter.svg'
import { ReactComponent as Close } from 'assets/img/ic_close.svg'
import SidePopover from 'components/common/Popover/SidePopover'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { formatMessage } from 'lib/intl'
import { createMyJobDataViewFilters } from 'helpers/myJobs'
import FilterIcons from './FilterIcons'
import FilterSite from './FilterSite'
import FilterDateRange from './FilterDateRange'
import FilterDataField from './FilterDataField'
import FilterJob from './FilterJob'
import FilterTask from './FilterTask'
import FilterInput from './FilterInput'
import FilterInputType from './FilterInputType'
import FilterUnitGroup from './FilterUnitGroup'
import FilterUnit from './FilterUnit'
import ObserverFilter from './ObserverFilter'
import ExportButton from './ExportButton'

class FilterBar extends Component {
  state = {
    isMobileFilterOpen: false,
    isShowBadge: false,
  }

  onShowHiddenFilters = () => {
    const { setMyJobsDataViewerFilter, isPanelOpen } = this.props
    setMyJobsDataViewerFilter({
      filterPanelOpen: !isPanelOpen,
    })
  }

  setBadgeState = state => {
    this.setState({
      isShowBadge: state,
    })
  }

  handleMobileFilter = state => {
    this.setState({
      isMobileFilterOpen: state,
    })
  }

  handleResetFilter = () => {
    const { setMyJobsDataViewerFilter } = this.props
    const {
      site,
      filterPanelOpen,
      densePadding,
      ...resetFilters
    } = createMyJobDataViewFilters()

    setMyJobsDataViewerFilter(resetFilters)
    this.setBadgeState(false)
  }

  renderMobileMenu = () => {
    const { isMobileFilterOpen, isShowBadge } = this.state

    return (
      <SidePopover
        open={isMobileFilterOpen}
        close={() => this.handleMobileFilter(false)}
        position="bottom"
        className="mobile-filter"
        classes={{
          paper: 'mobile-filter-paper',
        }}>
        <div className="mobile-filter-header">
          <IconButton
            onClick={() => this.handleMobileFilter(false)}
            className="close-btn">
            <Close />
          </IconButton>
          <Typography variant="h6" className="filter-caption">
            {formatMessage('parameters')}
          </Typography>
          <Button
            size="small"
            className="clear-btn"
            onClick={this.handleResetFilter}
            disabled={!isShowBadge}>
            {formatMessage('clear')}
          </Button>
        </div>
        <div className="mobile-filter-body">
          <div className="form-group">
            <FilterSite />
          </div>
          <div className="form-group">
            <FilterDateRange />
          </div>
          <div className="form-group">
            <FilterDataField />
          </div>
          <div className="form-group">
            <FilterJob />
          </div>
          <div className="form-group">
            <FilterTask />
          </div>
          <div className="form-group">
            <FilterInput />
          </div>
          <div className="form-group">
            <FilterUnitGroup />
          </div>
          <div className="form-group">
            <FilterUnit />
          </div>
          <Button
            fullWidth
            size="large"
            color="primary"
            variant="contained"
            className="apply-btn"
            onClick={() => this.handleMobileFilter(false)}>
            {formatMessage('apply')}
          </Button>
        </div>
      </SidePopover>
    )
  }

  render() {
    const { isPanelOpen } = this.props
    const { isShowBadge } = this.state

    return (
      <>
        {ifWindowWidthLessThan(768) && (
          <Grid
            container
            spacing={3}
            justify="space-between"
            alignItems="center"
            className="mobile-filters-control">
            <IconButton onClick={() => this.handleMobileFilter(true)}>
              <Badge variant="dot" invisible={!isShowBadge}>
                <Tune />
              </Badge>
            </IconButton>
            <ExportButton />
            <FilterIcons
              isShowFilters={isPanelOpen}
              onShowHiddenFilters={this.onShowHiddenFilters}
              onResetFilters={this.handleResetFilter}
              getBadgeState={this.setBadgeState}
            />
          </Grid>
        )}
        {ifWindowWidthLessThan(768) ? (
          this.renderMobileMenu()
        ) : (
          <>
            <Grid item container spacing={3}>
              <Grid item md={2} sm={3}>
                <FilterSite />
              </Grid>
              <Grid item md={3} sm={4}>
                <FilterDateRange />
              </Grid>
              <Grid item md={2} sm={3}>
                <FilterDataField />
              </Grid>
              <Grid item md={1} sm={1} className="filter-control">
                <FilterIcons
                  isShowFilters={isPanelOpen}
                  onShowHiddenFilters={this.onShowHiddenFilters}
                  onResetFilters={this.handleResetFilter}
                  getBadgeState={this.getBadgeState}
                />
              </Grid>
              <Grid
                item
                container
                md={4}
                sm={1}
                justify="flex-end"
                alignItems="flex-end">
                <ExportButton />
              </Grid>
            </Grid>
            <Collapse in={isPanelOpen} className="collapse-filter-block">
              <Grid container spacing={3}>
                <Grid item sm={2}>
                  <FilterJob />
                </Grid>
                <Grid item sm={2}>
                  <FilterTask />
                </Grid>
                <Grid item sm={2}>
                  <FilterInput />
                </Grid>
                <Grid item sm={2}>
                  <FilterUnitGroup />
                </Grid>
                <Grid item sm={2}>
                  <FilterUnit />
                </Grid>
                <Grid item sm={2}>
                  <FilterInputType />
                </Grid>
              </Grid>
            </Collapse>
          </>
        )}
        <ObserverFilter />
      </>
    )
  }
}

FilterIcons.defaultProps = {
  getBadgeState: () => {},
  onShowHiddenFilters: () => {},
  onResetFilters: () => {},
}

FilterBar.propTypes = {
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
  isPanelOpen: PropTypes.bool.isRequired,
}

export default connect(null, {
  setMyJobsDataViewerFilter,
})(FilterBar)
